import type { Liveness } from '../hooks/useRobots.ts';
import { LIVENESS_STATE } from './state.ts';
import { StatusDot } from './StatusDot.tsx';
import styles from './StatusBadge.module.css';

/* ==========================================================================
   Connectivity — a different dimension from operational status.

   Set in mono, because it is a derived machine fact rather than an operator's
   word, and because that visual difference stops the two columns of a fleet
   table from reading as one thing. `offline` and `provisioning` draw hollow:
   nothing is arriving, and shape says so before colour does.
   ========================================================================== */

const LOUD: ReadonlySet<Liveness> = new Set<Liveness>(['backfilling', 'offline']);

export function LivenessBadge({
  liveness,
  /** Pulse the dot only where the surface is genuinely showing a live stream. */
  pulse = false,
}: {
  liveness: Liveness;
  pulse?: boolean | undefined;
}) {
  const s = LIVENESS_STATE[liveness];
  return (
    <span
      className={styles.badge}
      data-tone={s.tone}
      data-loud={LOUD.has(liveness)}
      data-mono="true"
      title={s.hint}
    >
      <StatusDot
        tone={s.tone}
        hollow={s.hollow}
        pulse={pulse && liveness === 'live'}
      />
      <span className={styles.label}>{s.label}</span>
    </span>
  );
}
